export default __webpack_public_path__ + "static/media/1970.5d2dec7e.png";